import { push } from 'modules/gtm/modules/common';

export const gtmPushPromotionTileView = ({
  promotion_id,
  promotion_name,
  location_id,
  creative_name,
  video_type,
}: Record<string, string | undefined>) => {
  return push({
    event: 'Ecommerce - Promotion view',
    event_name: 'view_promotion',
    view_promotion: {
      video_type,
      currency: 'EUR',
      items: [
        {
          promotion_id,
          promotion_name,
          creative_name,
          location_id,
        },
      ],
    },
  });
};

export const gtmPushPromotionTileClick = ({
  promotion_id,
  promotion_name,
  location_id,
  creative_name,
  video_type,
}: Record<string, string | undefined>) => {
  return push({
    event: 'Ecommerce - Select promotion',
    event_name: 'select_promotion',
    select_promotion: {
      video_type,
      currency: 'EUR',
      items: [
        {
          promotion_id,
          promotion_name,
          creative_name,
          location_id,
        },
      ],
    },
  });
};
